export const epk_1 = {
	epk_1_1: require('@/assets/images/epk/1/1.png'),
	epk_1_2: require('@/assets/images/epk/1/2.png'),
	epk_1_3: require('@/assets/images/epk/1/3.png'),
	epk_1_4: require('@/assets/images/epk/1/4.png'),
	epk_1_5: require('@/assets/images/epk/1/5.png'),
	epk_1_6: require('@/assets/images/epk/1/6.png'),
	epk_1_7: require('@/assets/images/epk/1/7.png'),
	epk_1_8: require('@/assets/images/epk/1/8.png'),
	epk_1_9: require('@/assets/images/epk/1/9.png'),
};

export const epk_2 = {
	epk_2_1: require('@/assets/images/epk/2/1.png'),
	epk_2_2: require('@/assets/images/epk/2/2.png'),
};

export const epk_3 = {
	epk_3_1: require('@/assets/images/epk/3/1.png'),
	epk_3_2: require('@/assets/images/epk/3/2.png'),
	epk_3_3: require('@/assets/images/epk/3/3.png'),
	epk_3_4: require('@/assets/images/epk/3/4.png'),
	epk_3_5: require('@/assets/images/epk/3/5.png'),
	epk_3_6: require('@/assets/images/epk/3/6.png'),
	epk_3_7: require('@/assets/images/epk/3/7.png'),
};

export const epk_4 = {
	epk_4_1: require('@/assets/images/epk/4/1.png'),
	epk_4_2: require('@/assets/images/epk/4/2.png'),
	epk_4_3: require('@/assets/images/epk/4/3.png'),
	epk_4_4: require('@/assets/images/epk/4/4.png'),
};

export const epk_5 = {
	epk_5_1: require('@/assets/images/epk/5/1.png'),
	epk_5_2: require('@/assets/images/epk/5/2.png'),
	epk_5_3: require('@/assets/images/epk/5/3.png'),
	epk_5_4: require('@/assets/images/epk/5/4.png'),
	epk_5_5: require('@/assets/images/epk/5/5.png'),
	epk_5_6: require('@/assets/images/epk/5/6.png'),
	epk_5_7: require('@/assets/images/epk/5/7.png'),
};

export const epk_6 = {
	epk_6_1: require('@/assets/images/epk/6/1.png'),
	epk_6_2: require('@/assets/images/epk/6/2.png'),
};

export const epk_7 = {
	epk_7_1: require('@/assets/images/epk/7/1.png'),
};

export const epk_8 = {
	epk_8_1: require('@/assets/images/epk/8/1.png'),
	epk_8_2: require('@/assets/images/epk/8/2.png'),
	epk_8_3: require('@/assets/images/epk/8/3.png'),
	epk_8_4: require('@/assets/images/epk/8/4.png'),
	epk_8_5: require('@/assets/images/epk/8/5.png'),
	epk_8_6: require('@/assets/images/epk/8/6.png'),
	epk_8_7: require('@/assets/images/epk/8/7.png'),
};

export const epk_9 = {
	epk_9_1: require('@/assets/images/epk/9/1.png'),
	epk_9_2: require('@/assets/images/epk/9/2.png'),
	epk_9_3: require('@/assets/images/epk/9/3.png'),
	epk_9_4: require('@/assets/images/epk/9/4.png'),
	epk_9_5: require('@/assets/images/epk/9/5.png'),
	epk_9_6: require('@/assets/images/epk/9/6.png'),
};
